import api from "./api";

export const getConstants = (params) => {
  return api.get("/v1/config/constants", params);
};
